<!--
    Header nav icon, exported from Figma 4933-40092 (Search Icon).
    Kept as a `nav-` set separate from the app's older icons: these carry the
    comp's line weights (1.25 in a ~22px box, 1.0 in the 18px hamburger), which
    the previous mix did not, and swapping the shared icons would change them
    everywhere else too. `currentColor` so the header controls the colour.
-->
<template>
    <svg aria-hidden="true" focusable="false" width="22.6248" height="22.6248" viewBox="0 0 22.6248 22.6248" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
    <circle cx="9.24" cy="9.24" r="8.615" stroke="currentColor" stroke-width="1.25"/>
    <path d="M15.8398 15.8398L21.9998 21.9998" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
    </g>
    </svg>
</template>
